export function getAuthRedirectUri() {
  if (typeof window !== 'undefined') {
    return `${window.location.origin.replace(/\/+$/, '')}/`
  }

  const configuredOrigin = import.meta.env.VITE_AUTH_APP_ORIGIN?.trim()

  if (!configuredOrigin) {
    return undefined
  }

  return `${configuredOrigin.replace(/\/+$/, '')}/`
}
